if (!customElements.get('deal-promotion-info')) {
  class DealPromotionInfo extends HTMLElement {
    constructor() {
      super();
      this.hoverMedia = window.matchMedia('(hover: hover) and (pointer: fine)');
      this.handleMouseEnter = this.handleMouseEnter.bind(this);
      this.handleMouseLeave = this.handleMouseLeave.bind(this);
      this.handleSummaryClick = this.handleSummaryClick.bind(this);
      this.handleDocumentPointerDown = this.handleDocumentPointerDown.bind(this);
      this.handleDocumentKeydown = this.handleDocumentKeydown.bind(this);
    }

    connectedCallback() {
      this.details = this.querySelector('details');
      this.summary = this.querySelector('summary');
      if (!this.details || !this.summary) return;

      this.addEventListener('mouseenter', this.handleMouseEnter);
      this.addEventListener('mouseleave', this.handleMouseLeave);
      this.summary.addEventListener('click', this.handleSummaryClick);
      document.addEventListener('pointerdown', this.handleDocumentPointerDown);
      document.addEventListener('keydown', this.handleDocumentKeydown);
    }

    disconnectedCallback() {
      this.removeEventListener('mouseenter', this.handleMouseEnter);
      this.removeEventListener('mouseleave', this.handleMouseLeave);
      this.summary?.removeEventListener('click', this.handleSummaryClick);
      document.removeEventListener('pointerdown', this.handleDocumentPointerDown);
      document.removeEventListener('keydown', this.handleDocumentKeydown);
    }

    handleMouseEnter() {
      if (this.hoverMedia.matches) this.details.open = true;
    }

    handleMouseLeave() {
      if (this.hoverMedia.matches) this.details.open = false;
    }

    handleSummaryClick(event) {
      if (this.hoverMedia.matches && event.detail > 0) {
        event.preventDefault();
        this.details.open = true;
      }
    }

    handleDocumentPointerDown(event) {
      if (this.details.open && !this.contains(event.target)) {
        this.details.open = false;
      }
    }

    handleDocumentKeydown(event) {
      if (event.key === 'Escape' && this.details.open) {
        this.details.open = false;
        this.summary.focus();
      }
    }
  }

  customElements.define('deal-promotion-info', DealPromotionInfo);
}
